export const AcademicoGerenciamento = {
    // Letra A:
    // Letra B:
    BREADCRUMB: 'Academic panel',
    // Letra C:
    // Letra D:
    // Letra E:
    // Letra F:
    FECHAMENTO_PERIODO: 'School term ending'
    // Letra G:
    // Letra H:
    // Letra I:
    // Letra J:
    // Letra K:
    // Letra L:
    // Letra M:
    // Letra N:
    // Letra O:
    // Letra P:
    // Letra Q:
    // Letra R:
    // Letra S:
    // Letra T:
    // Letra U:
    // Letra V:
    // Letra X:
    // Letra Y:
    // Letra Z:
}